module.exports = __webpack_public_path__ + "svg/flags/Cocos (Keeling) Islands.svg";